import Cookies from 'js-cookie'

const TokenKey = 'hemind-Token'
const UsernameKey = 'hemind-Username'
const NicknameKey = 'hemind-Nickname'
const AvatarKey = 'hemind-Avatar'
const RolesKey = 'hemind-Roles'
const UserIdKey = 'hemind-UserId'

//LocalStorage
export function getLocalStorageToken() {
    return localStorage.getItem(TokenKey);
}
export function setLocalStorageToken(token) {
    return localStorage.setItem(TokenKey, token);
}
export function removeLocalStorageToken() {
    return localStorage.removeItem(TokenKey)
}

export function getLocalStorageUsername() {
    return localStorage.getItem(UsernameKey);
}
export function setLocalStorageUsername(Username) {
    return localStorage.setItem(UsernameKey, Username);
}
export function removeLocalStorageUsername() {
    return localStorage.removeItem(UsernameKey)
}

export function getLocalStorageNickname() {
    return localStorage.getItem(NicknameKey);
}
export function setLocalStorageNickname(Nickname) {
    return localStorage.setItem(NicknameKey, Nickname);
}
export function removeLocalStorageNickname() {
    return localStorage.removeItem(NicknameKey)
}

export function getLocalStorageAvatar() {
    return localStorage.getItem(AvatarKey);
}
export function setLocalStorageAvatar(Avatar) {
    return localStorage.setItem(AvatarKey, Avatar);
}
export function removeLocalStorageAvatar() {
    return localStorage.removeItem(AvatarKey)
}

export function getLocalStorageRoles() {
    return localStorage.getItem(RolesKey);
}
export function setLocalStorageRoles(Roles) {
    return localStorage.setItem(RolesKey, Roles);
}
export function removeLocalStorageRoles() {
    return localStorage.removeItem(RolesKey)
}

export function getLocalStorageUserId() {
    return localStorage.getItem(UserIdKey);
}
export function setLocalStorageUserId(UserId) {
    return localStorage.setItem(UserIdKey, UserId);
}
export function removeLocalStorageUserId() {
    return localStorage.removeItem(UserIdKey)
}

//cookie
export function getToken() {
  return Cookies.get(TokenKey)
}
export function getUsername() {
  return Cookies.get(UsernameKey)
}
export function getNickname() {
  return Cookies.get(NicknameKey)
}
export function getAvatar() {
  return Cookies.get(AvatarKey)
}
export function getRoles() {
  return Cookies.get(RolesKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function setUsername(username) {
  return Cookies.set(UsernameKey, username)
}
export function setNickname(nickname) {
  return Cookies.set(NicknameKey, nickname)
}
export function setAvatar(avatar) {
  return Cookies.set(AvatarKey, avatar)
}
export function setRoles(roles) {
  return Cookies.set(RolesKey, roles)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function removeUsername() {
  return Cookies.remove(UsernameKey)
}
export function removeNickname() {
  return Cookies.remove(NicknameKey)
}
export function removeAvatar() {
  return Cookies.remove(AvatarKey)
}
export function removeRoles() {
  return Cookies.remove(RolesKey)
}

/*
用法：
localStorage.lastname = 'JSAnntQ';
localStorage['lastname'] = 'JSAnntQ';
localStorage.setItem("lastname", "JSAnntQ");

localStorage.lastname
localStorage['lastname']
localStorage.getItem("lastname");*/
